import { useEffect } from 'react';

export interface OrganizationSchemaProps {
  name?: string;
  url?: string;
  logo?: string;
  description?: string;
  contactEmail?: string;
  sameAs?: string[];
}

export function OrganizationSchema({
  name = 'BasedOn',
  url = 'https://based-on.net',
  logo = 'https://based-on.net/logo.png',
  description = 'Professional Power BI custom visuals and productivity tools designed to streamline workflows and enhance dashboard clarity.',
  contactEmail = 'support@based-on.net',
  sameAs = [],
}: OrganizationSchemaProps) {
  useEffect(() => {
    const scriptId = 'jsonld-organization';
    let script = document.getElementById(scriptId) as HTMLScriptElement;
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name,
      url,
      logo: {
        '@type': 'ImageObject',
        url: logo,
      },
      description,
      contactPoint: {
        '@type': 'ContactPoint',
        email: contactEmail,
        contactType: 'Customer Support',
        availableLanguage: ['English'],
      },
      ...(sameAs.length > 0 && { sameAs }),
    };
    
    script.textContent = JSON.stringify(schema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [name, url, logo, description, contactEmail, sameAs]);

  return null;
}
